import { ResourceType } from '@cotera/api';
import { resourceViewOf } from '@cotera/sdk/core';
import type { TenantedClient } from '@cotera/client/app/etc/api/typed-client';
import type { NonFolderResourceType } from '../resources/type/resource-type-config';

type ResourceGetClient = Pick<TenantedClient['resource'], 'get'>;

function readFolderIdFromGetResponse(
  response: Awaited<ReturnType<ResourceGetClient['get']>>
): string | undefined {
  if (response.isErr()) {
    return undefined;
  }
  return resourceViewOf(response.value).folderId() ?? undefined;
}

export async function resolveArtifactFolderId(
  client: ResourceGetClient,
  resourceType: NonFolderResourceType,
  artifactId: string,
  explicitFolderId: string | undefined
): Promise<string | undefined> {
  if (explicitFolderId !== undefined) {
    return explicitFolderId;
  }

  const result = await client.get({
    type: resourceType,
    id: artifactId,
  });

  return readFolderIdFromGetResponse(result);
}

export function resourceTypeForChatSeedType(
  seedType: string
): NonFolderResourceType | undefined {
  switch (seedType) {
    case 'agent':
      return ResourceType.Agent;
    case 'workflow':
      return ResourceType.Workflow;
    default:
      return undefined;
  }
}
